import { BusinessError } from './businessError';

export class NotAllowedError extends BusinessError {
    public name = 'NotAllowedError';
}
